"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const plugins_1 = require("../plugins");
class BucketHandler extends plugins_1.FdmBucketPlugin {
    constructor() {
        super(...arguments);
        // the bucket.component we're drawing to
        this.component = null;
        // the action controller that deals with data and interaction
        this.actionController = null;
    }
    registerComponent(c = null) {
        if (c) {
            this.component = c;
        }
    }
    registerActionController(c = null) {
        if (c) {
            this.actionController = c;
        }
    }
    end() {
        if (this.actionController) {
            this.actionController.destroy();
        }
    }
    emptyController() {
        if (this.actionController) {
            this.actionController.unloadAllItems();
        }
    }
    tell(action = 'update', data = null) {
        // console.log ( 'BUCKET_HANDLER tell()', this, data );
        if (this.actionController) {
            this.actionController.unloadAllItems();
            // console.log ( 'BUCKET_HANDLER TOLD!!', this.actionController );
            this.actionController.config({ object: data });
        }
    }
}
// required name identifier
BucketHandler.meta = {
    name: 'bucket-handler',
    translator: 'PLUGINS.GUIDES_CONTROLLER',
    category: plugins_1.FdmPlugin.category.generic,
    cardinality: plugins_1.FdmPlugin.cardinality.one,
    types: [plugins_1.FdmPlugin.types.bucketsController]
};
exports.BucketHandler = BucketHandler;
